<template>
  <section>
    <div class="container title-area">
      <div class="columns is-centered">
        <div class="column is-full">
          <h3 class="is-size-5 has-text-weight-bold has-text-black-ter start-title" v-html="crow?'':introText"></h3>
          <b-field label="Naam" v-if="name_enabled">
            <b-input class="text-input center" v-model="startData.name" validation-message="Naam is verplicht" :required="name_required"></b-input>
          </b-field>
          <b-field label="E-mail" v-if="email_enabled || hasValidation">
            <b-input class="text-input center" type="email" v-model="startData.email" validation-message="E-mailadres is verplicht" :required="email_required || hasValidation"></b-input>
          </b-field>
          <b-field label="Functie" class="center" v-if="respondent_function_enabled">
            <b-input class="text-input center" v-model="startData.respondent_function" :required="respondent_function_required"></b-input>
          </b-field>
          <a class="button has-text-weight-bold is-rounded start-button" :disabled="!this.formValidated" @click="startSurvey()" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}" v-html="startButtonText"></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  const CREATE = '/survey/create'

    export default {
      name: 'start',
      data () {
        return {
          name_enabled: this.$store.getters.getInfo.name_enabled,
          email_enabled: this.$store.getters.getInfo.email_enabled,
          respondent_function_enabled: this.$store.getters.getInfo.respondent_function_enabled,
          name_required: this.$store.getters.getInfo.name_required,
          email_required: this.$store.getters.getInfo.email_required,
          respondent_function_required: this.$store.getters.getInfo.respondent_function_required,
          fillableOnce: this.$store.getters.getInfo.fillable_once,
          fillableMultipleRespondents: this.$store.getters.getInfo.fillable_multiple_respondents,
          forumId: this.$store.getters.getInfo.form_id,
          startData: this.$store.getters.getStartData,
          token: this.$store.getters.getToken,
          crow: this.$store.getters.getCrow,
          hasValidation: this.$store.getters.getSurveySettings.emailValidation
        }
      },
      props: {
        introText: String,
        startButtonText: String
      },
      computed: {
        formValidated () {
          let v = this;
          let validated = []
          let formFields = ['name','email','respondent_function']

          formFields.forEach((field) => {
            if((this[field+'_enabled'] && this[field+'_required']) || (field == 'email' && v.hasValidation)) {
              if(field == 'email')
              {
                validated.push(JSON.stringify(this.validateEmail(this.startData[field])))
              }
              if (this.startData[field]) {
                validated.push('true')
              } else {
                validated.push('false')

              }
            } else {
              validated.push('true')
            }
          })
          // console.log(validated);
          if (validated.includes('false')){
            return false
          } else {
            return true
          }
        }
      },
      methods: {
        validateEmail(email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
        },
        snackbarDanger(message) {
                this.$snackbar.open({
                    duration: 8000,
                    message: message,
                    type: 'is-danger',
                    position: 'is-bottom',
                    // actionText: 'Undo',
                    queue: false,
                })
            },
        startSurvey () {
          // this.$emit('form-status', 'start')
          if(this.formValidated)
          {
            this.$store.commit('setStartData', this.startData)
            this.createSurvey()
          }
          else {
            this.snackbarDanger('Vul bovenstaande velden correct in')
          }
        },
        createSurvey () {
          this.$http
            .post(process.env.EMET_API_URL + CREATE, { form_id: this.forumId, data: this.startData, token: this.token, fillableOnce: this.fillableOnce, fillableMultipleRespondents: this.fillableMultipleRespondents}, {emulateJSON: true})
            .then(function (response) {
              // console.log(response)
                if (response.data.status) {
                    // console.log(response.data.status);
                    if (response.data.survey.crow == true) this.initializeCrow(response.data.survey);
                    else
                    {
                      this.$store.commit('setSurvey', response.data.survey)
                      this.$store.commit('setActivities', response.data.survey.activities)
                    }
                    // this.$store.commit('setProject', response.data.project)
                    this.$store.commit('setActiveActivity', 0)
                    this.$store.commit('setActiveQuestion', 0)
                    this.$store.commit('clearUploads')
          
                    this.$emit('form-status', 'start')
                } else {
                  this.snackbarDanger(response.data.msg)
                }
            }, function (error) {
                console.log('error during API call')
            })
        },
        initializeCrow (form) {
          // console.log('initcrow');
           var activities = form.activities ? form.activities : [];

           activities.forEach( function(activity, i){
             activity['name'] = activity['name'].replace("(CROW werken) ", "").replace("(CROW diensten) ", "");
             activity['questions'].forEach(function(question, j){
               if (question['question_type'] == 'select_multiple_one' || question['question_type'] == 'checkbox_multiple_multiple')
               {
                 question['values'].forEach(function(value, k){
                   activities[i]['questions'][j]['values'][k] = value.replace(/ [^ ]+$/ig, '');
                 });
               }
             });
           });
           form.activities = activities;

           this.$store.commit('setActivities', activities);
           this.$store.commit('setSurvey', form);
       }
      }
    }
</script>

<style scoped>

.flex-center {
  display: flex;
  justify-content: center;
}

.privacy {
  margin-top: 40px;
}

.privacy > div {
  display: flex;
}

.w-50 {
  width: 40%;
}

.title-area {
  margin-top: 42px;
  margin-bottom: 60px;
  text-align: center;
}

.start-title {
  padding-bottom: 42px;
  /* color: #111f39; */
}

.start-button {
  background-color: #00294c;
  border-color: #00294c;
  font-size: 16px;
  font-weight: bold;
  color: white;
  padding-bottom: 8px;
  margin-top: 30px;
  width: 180px;
  height: 40px;
  transition: width 0.3s;
}

.start-button:hover {
  background-color: #003766;
  border-color: #003766;
  font-weight: bold;
  color: white;
  padding-bottom: 8px;
  width: 200px;
}

.center{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/intro/Start.vue